import React, { useState, useEffect } from 'react';
import { isEmpty } from '../../../utilities/methods';
import { toast } from "react-toastify";
import * as roomRTC from "../../../services/roomRTC";
import * as roomWSS from "../../../services/roomWSS";

import "../Chats.css";

const ChatNewMessage = ({ username, roomSocketId, conversationActive, notifyMessage }) => {
    const [message, setMessage] = useState("");
    const [processedIds, setProcessedIds] = useState([]);

    const notify = (message) => {
        toast(message);
    };

    const handleTextChanged = (e) => {
        setMessage(e.target.value);
    };

    const handleKeyPressed = (e) => {
        if (e.key === "Enter") {
            e.preventDefault();

            handleSendMessage();
        }
    };

    const handleSendMessage = async () => {
        if (!isEmpty(username) && !isEmpty(message) && conversationActive) {
            const socketId = conversationActive.roomSocketId;
            const actor = conversationActive.username;

            await roomRTC.sendNotifyMessageDataChannel(socketId, username, actor);

            roomWSS.sendDirectMessage({
                receiverSocketId: socketId,
                username: username,
                content: message,
            });

            setMessage("");
        }
    };

    useEffect(() => {
        if (notifyMessage && Array.isArray(notifyMessage) && notifyMessage.length > 0) {
            const newMessages = notifyMessage.filter(
                (nd) =>
                    nd.socketId === roomSocketId &&
                    nd.actor === username &&
                    !processedIds.includes(nd.avaluator) // evita repetir
            );

            // Notifica e salva os ids já processados
            newMessages.forEach((msg) => {
                const message = `${msg.avaluator} enviou uma mensagem privada.`;
                notify(message);
                setProcessedIds((prev) => [...prev, msg.avaluator]);
            });
        }
    }, [notifyMessage]);

    return (
        <div className='chat_new_message_container'>
            <div className='input_group_container'>
                <input
                    type="text"
                    value={message}
                    placeholder="Sua mensagem..."
                    onChange={handleTextChanged}
                    onKeyDown={handleKeyPressed}
                    className='form-control input_theme_style'
                />

                <span className="material-symbols-outlined btn_icon_circle"
                    title='Enviar mensagem' onClick={handleSendMessage}>send</span>
            </div>
        </div>
    );
};

export default ChatNewMessage;